<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="项目预留信息" name="1">
        <van-field v-model="inputForm.projectName" label="项目名称" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.principalName" label="负责人姓名" label-width="130px" v-if="inputForm.baseInfo&&['2', '3'].includes(inputForm.baseInfo.customerCategory)" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.mobile" label="联系电话" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.wechatNo" label="微信号" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.currentAddress" label="联系地址" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.sourceName" label="客户来源" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.houseTypeName" label="经营业态" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.brandName" label="经营品牌" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.propertyArea" label="意向面积（㎡）" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.areaName" label="意向经营区域" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.price" label="意向租赁价格（元/㎡/天）" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.userName" label="招商人员" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.chatTime" label="洽谈时间" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.customerIntentionName" label="意向等级" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.typeName" label="跟进方式" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.nextTime" label="下次跟进时间" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.nextContent" label="下次跟进内容" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="客户基本信息" name="2">
        <van-field v-model="inputForm.baseInfo.customerName" label="客户名称" label-width="130px" v-if="inputForm.baseInfo" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.customerCategoryName" label="客户类别" label-width="130px" v-if="inputForm.baseInfo" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.mobile" label="联系电话" label-width="130px" v-if="inputForm.baseInfo" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.sexName" label="性别" label-width="130px" v-if="inputForm.baseInfo&&inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.birthdate" label="出生年月" label-width="130px" v-if="inputForm.baseInfo&&inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.legalPerson" label="法定代表人" label-width="130px" v-if="inputForm.baseInfo&&inputForm.baseInfo.customerCategory === '2'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.legalPersonMobile" label="法定代表人联系电话" label-width="130px" v-if="inputForm.baseInfo&&inputForm.baseInfo.customerCategory === '2'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.isDeveloper" label="是否开发商" label-width="130px" v-if="inputForm.baseInfo&&inputForm.baseInfo.customerCategory === '2'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.remarks" label="备注" label-width="130px" v-if="inputForm.baseInfo" readonly autosize rows='1'
                   type="textarea"/>
        <div style="padding-left: 16px;" v-show="inputForm.baseInfo">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.baseInfo.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field label="跟进记录" label-width="100px" readonly>
          <template #button>
            <van-button plain type="default" @click="view">查看跟进记录</van-button>
          </template>
        </van-field>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import CustomerService from "@/api/contract/CustomerService";
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        projectId: '',
        area: '',
        houseType: '',
        floor: '',
        houseStatus: '',
        type: '',
        houseUseStatus: '',
        code: '',
        propertyArea: '',
        isEnabled: '1',
        remark: '',
        areaName: '',
        isDoTask: false,
        isLastTask: false
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      followList:[],
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(this.businessId)
    // this.init('1775351866996748289')
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new CustomerService().queryById(id).then(({data}) => {
        this.inputForm = data
        this.$set(this.inputForm.baseInfo, `sexName`,this.inputForm.baseInfo.sex==1?'男':'女' );
        this.$set(this.inputForm.baseInfo, `customerCategoryName`,this.inputForm.baseInfo.customerCategory==1?'个人':this.inputForm.baseInfo.customerCategory==2?'单位':'虚拟客户' );
        // this.$set(this.inputForm, `dateRange`,`${this.inputForm.startDate}至${this.inputForm.endDate}` );
        new CustomerService().listAll(this.inputForm.id).then(({ data }) => {
          this.followList = data.records;
        })
      }).catch(e => {
        console.log(e)
      })
    },
    view() {
      this.$router.push({
        path: 'shye_customer_detail',
        query: {
          data: this.followList
        }
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'shye_finance_receivable_adjust',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
            _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
            new CustomerService().startFlow(_this.inputForm);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
            _this.inputForm.flowType = 3;
            new CustomerService().startFlow(_this.inputForm);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
